import { JobPriorityType, JobStatusType, JobType } from '@/enum'
import { Job, JobAssociatedAsset } from './jobs'
import { getJobStatusColor } from '@/utils/helpers'
import AssignedEmployee from './employees/AssignedEmployee'
import type { IAssignedEmployee, IJobAssociatedAsset } from '@/interfaces'

class CalendarEvent {
  id: string
  title: string
  start: Date | null
  end: Date | null
  color: string
  assignedEmployees?: IAssignedEmployee[]
  draggable: boolean
  type: JobType
  jobNumber: string
  status: JobStatusType
  classNames: string[]
  textColor: string
  startEditable: boolean
  durationEditable: boolean
  allDay?: boolean
  priority?: JobPriorityType
  asset: IJobAssociatedAsset

  constructor(event: Job) {
    const eventStartDate = event.startedAt ?? event.scheduledAt

    this.id = event.id!
    this.title = event.title
    this.start = eventStartDate ? new Date(eventStartDate) : null
    this.end =
      event.completedAt || event.dueAt ? new Date((event.completedAt || event.dueAt)!) : null
    this.asset = new JobAssociatedAsset(event.asset)
    this.color = getJobStatusColor(event.status)
    this.assignedEmployees = event.assignedEmployees?.map(
      (assignedEmployee: any) => new AssignedEmployee(assignedEmployee)
    )
    this.draggable = [JobStatusType.OPEN, JobStatusType.SCHEDULED].includes(event.status) && this.isAssetAvaiable()
    this.type = event.type!
    this.jobNumber = event.number
    this.status = event.status
    this.classNames = ['bg-transparent border-0']
    this.textColor = '#000000'
    this.startEditable = [JobStatusType.OPEN, JobStatusType.SCHEDULED].includes(event.status) && this.isAssetAvaiable()
    this.durationEditable = event.status !== JobStatusType.COMPLETED
    this.priority = event.priority
  }

  isAssetAvaiable() {
    const { vehicle, machine, equipment } = this.asset
    return !(vehicle.archivedAt || machine.archivedAt || equipment.archivedAt)
  }
}

export default CalendarEvent
